
const URL_API_BACKEND = 'https://api-staging.espace-ambassadeur.fr/';

export const environment = {
    production: false,
    ENV_NAME: 'staging',
    URL_API_BACKEND: URL_API_BACKEND,
    URL_API_BACKEND_GRAPHQL: URL_API_BACKEND + 'gql/',
    URL_API_BACKEND_REST: URL_API_BACKEND + 'rest/',
    COOKIE_LOGIN: 'token_login',
    COOKIE_DOMAIN: '.espace-ambassadeur.fr',
    PREFIX_LOCALSTORAGE: 'pwa',
    GOOGLE_TAG_MANAGER_ID: 'GTM-NJ5M585T',
    GOOGLE_MAPS_API_KEY: 'AIzaSyBLw9Naa9KrW3K-yMUwo6OkGjRN66uPAAk',
    CLOUDINARY: {
        BASE_URL: "https://api.cloudinary.com/v1_1/",
        CLOUD_NAME: "demooz",
        UPLOAD_PATH_AUTO: "/auto/upload",
        UPLOAD_PATH_IMAGE: "/image/upload",
        UPLOAD_PATH_VIDEO: "/video/upload",
        API_KEY: "789914497635536"
    },
    CHALLENGE_ID : {
        DEMONSTRATION: 'demonstration',
        SALE: 'sale',
        LEVEL: 'level'
    },    
    CHALLENGE_TYPE : {
        PUBLICATION: 'publication',
        REVIEW: 'review',
        EVENT: 'event',
        EXTERNAL: 'external',
        DEMONSTRATION: 'demonstration',
        SALE: 'sale',
    },    
    CHALLENGE_VALIDATION_TYPE: {
        VALIDATED: "validated",
        DENIED: "denied",
        DENIED_DEFINITELY: "denied_definitely",
        AWAITING_VALIDATION: "awaiting_validation"
    }
};
